import { defineStore } from "pinia";

export const useProductRangeStore = defineStore('productRange', {
    state: () => ({
        productRange: {},
        productRanges: [],
    }),
    actions: {
        setProductRange(productRange) {
            this.productRange = productRange
        },
        setProductRanges(productRanges) {
            this.productRanges = productRanges
        },
        addProductRange(productRange) {
            this.productRanges.unshift(productRange)
        },
        updateProductRange(productRange) {
            let index = this.productRanges.findIndex(cl => cl.id === productRange.id)
            this.productRanges.splice(index, 1, productRange)
        },
        deleteProductRange(productRange) {
            let index = this.productRanges.findIndex(cl => cl.id === productRange.id)
            this.productRanges.splice(index, 1)
        },
    },
});